import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { RootState, WkblVideoState } from 'redux/reducers/type';
import {
  Button,
  ClickAwayListener,
  Grow,
  makeStyles,
  MenuList,
  Paper,
  Popper,
  Theme,
  Typography,
} from '@material-ui/core';
import { ScriptOptions } from 'commons/constants/KeyFlowConstants';
import CodeVO from 'commons/vo/CodeVO';
import { SelectIcon } from 'asset/images';
import { RecordOptions } from 'components/SelectOptions';
import { RecordOptionType, RecordSelectProps } from 'components/Select/type';

const useStyles = makeStyles((theme: Theme) => ({
  sortOptionButton: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    border: '1px solid #b6b6b6',
    borderRadius: 0,
  },
  buttonTitle: {
    flexBasis: '95%',
    textAlign: 'left',
  },
  popper: {
    zIndex: theme.zIndex.tooltip,
    width: 'calc(100% - 130px)',
  },
  paper: {
    borderRadius: 0,
    maxHeight: '250px',
    overflowY: 'scroll',
  },

  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function RecordSelect({ selectedRecords, onClickRecord }: RecordSelectProps) {
  const classes = useStyles();

  const [button, setButton] = useState<null | HTMLButtonElement>(null);
  const isOpen = useMemo(() => Boolean(button), [button]);

  const onOpenMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setButton(event.currentTarget);
  }, []);

  const onCloseMenu = useCallback(() => {
    setButton(null);
  }, []);

  const selectedRecordsString = () => {
    if (selectedRecords.length > 0) {
      const firstItem = selectedRecords[0];
      const itemCount = selectedRecords.length;
      const gameTypeName = ScriptOptions.find(
        (record: RecordOptionType) => record.value === firstItem,
      );
      const otherName = itemCount > 1 ? ` 외 ${itemCount - 1} 개` : '';

      return gameTypeName ? `${gameTypeName.name}${otherName}` : null;
    } else {
      return '항목을 선택해주세요';
    }
  };

  return (
    <>
      <Button className={clsx(classes.sortOptionButton)} onClick={onOpenMenu}>
        <Typography className={clsx(classes.ellipsis, classes.buttonTitle)}>
          {selectedRecordsString()}
        </Typography>
        <img src={SelectIcon}></img>
      </Button>
      <Popper className={clsx(classes.popper)} open={isOpen} anchorEl={button} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'center top',
            }}
          >
            <Paper className={clsx(classes.paper)}>
              <ClickAwayListener onClickAway={onCloseMenu}>
                <MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={onCloseMenu}>
                  <RecordOptions selectedRecords={selectedRecords} onClickRecord={onClickRecord} />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default RecordSelect;
